import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { API_BASE_URL } from '../../config/constant';
import './Dashboard.css';

const Dashboard = () => {
    const navigate = useNavigate();
    const [user, setUser] = useState(null);
    const [dashboardData, setDashboardData] = useState([]);
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        const userData = localStorage.getItem('user');
        if (userData) {
            setUser(JSON.parse(userData));
        } else {
            navigate('/');
        }
    }, [navigate]);

    useEffect(() => {
        fetchDashboardData();
    }, []);

    const fetchDashboardData = async () => {
        setLoading(true);
        try {
            const response = await fetch(`${API_BASE_URL}/lead/vehicle_dashboard`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'apikey': 'd77bc90f-3350-47da-94c2-2930de73difauction'
                },
                body: JSON.stringify({})
            });

            const result = await response.json();
            
            if (result.status === 200) {
                setDashboardData(result.data);
            }
        } catch (error) {
            console.error('Error fetching dashboard data:', error);
        } finally {
            setLoading(false);
        }
    };

    const handleLogout = () => {
        localStorage.clear();
        navigate('/');
    };

    const handleCardClick = (title, filterParams) => {
        console.log(`Clicked on ${title} card`, filterParams);
        // Add navigation logic here based on filter_params
        if (filterParams.tab_id) {
            // Navigate to vehicles page with specific tab
            navigate('/vehicles', { state: { tabId: filterParams.tab_id } });
        } else {
            // Navigate to vehicles page without filter
            navigate('/vehicles');
        }
    };

    const getCardIcon = (title) => {
        const iconMap = {
            'All Vehicle': '🚗',
            'No Bids': '🚫',
            'Approval Pending': '📍',
            'Bids Received': '✅',
            'Re-submission': '❌',
            'Withdrawn': '↩️',
            'Auction Scheduled': '🔨',
            'Rejected': '👎',
            'Reauctioned': '🔄'
        };
        return iconMap[title] || '📊';
    };

    const getCardColor = (title) => {
        const colorMap = {
            'All Vehicle': '#BFF8FC',
            'No Bids': '#FFF1D6',
            'Approval Pending': '#FFECE2',
            'Bids Received': '#D2FCEB',
            'Re-submission': '#D8EAFF',
            'Withdrawn': '#FFECE2',
            'Auction Scheduled': '#D2FCEB',
            'Rejected': '#BFF8FC',
            'Reauctioned': '#FFF1D6'
        };
        return colorMap[title] || '#f8f9fa';
    };


    return (
        <div className="dashboard-container">
            {/* Header */}
            <div className="header-left-dashboard">
                <h1>Hello {user?.name || user?.firstName || 'User'}</h1>
                <p className="welcome-message">Welcome to OTO Auction</p>
            </div>

            {/* Cards Section */}
            <div className="cards-section">
                {loading ? (
                    <div className="loading-container">
                        <div className="loading-spinner"></div>
                    </div>
                ) : (
                    <>
                        {/* First Row */}
                        <div className="cards-row">
                            {dashboardData.slice(0, 5).map((item, index) => (
                                <div 
                                    key={index} 
                                    className={`dashboard-card ${item.count === 0 ? 'disabled' : ''}`}
                                    style={{ 
                                        backgroundColor: getCardColor(item.title),
                                        cursor: item.count === 0 ? 'not-allowed' : 'pointer'
                                    }}
                                    onClick={() => item.count > 0 && handleCardClick(item.title, item.filter_params)}
                                >
                                    <div className="card-icon">
                                        {item?.icon_className && (
                                            <i
                                                className={
                                                item.icon_className
                                                }
                                            >
                                                {item.max_icon_paths
                                                ? Array.from(
                                                    Array(
                                                        item.max_icon_paths
                                                    ).keys()
                                                    ).map((i,indexkey2) => (
                                                    <i key={indexkey2} className={`path${i + 1}`}></i>
                                                    ))
                                                : null}
                                            </i>
                                        )}
                                    </div>
                                    <div className="card-number">{item.count}</div>
                                    <div className="card-label">{item.title}</div>
                                </div>
                            ))}
                        </div>

                        {/* Second Row */}
                        <div className="cards-row">
                            {dashboardData.slice(5).map((item, index) => (
                                <div 
                                    key={index + 5} 
                                    className={`dashboard-card ${item.count === 0 ? 'disabled' : ''}`}
                                    style={{ 
                                        backgroundColor: getCardColor(item.title),
                                        cursor: item.count === 0 ? 'not-allowed' : 'pointer'
                                    }}
                                    onClick={() => item.count > 0 && handleCardClick(item.title, item.filter_params)}
                                >
                                    <div className="card-icon">
                                        {item?.icon_className && (
                                            <i
                                                className={
                                                item.icon_className
                                                }
                                            >
                                                {item.max_icon_paths
                                                ? Array.from(
                                                    Array(
                                                        item.max_icon_paths
                                                    ).keys()
                                                    ).map((i,indexkey2) => (
                                                    <i key={indexkey2} className={`path${i + 1}`}></i>
                                                    ))
                                                : null}
                                            </i>
                                        )}
                                    </div>
                                    <div className="card-number">{item.count}</div>
                                    <div className="card-label">{item.title}</div>
                                </div>
                            ))}
                        </div>
                    </>
                )}
            </div>
        </div>
    );
};

export default Dashboard;
